import React from 'react';
import PropTypes from 'prop-types';
import {compact, map} from 'lodash';
import styles from './application-status-carousel.module.scss';
import Carousel from 'shared/components/carousel';
import ApplicationStatusCard from 'shared/application-management/components/application-status-card';

const propTypes = {
  colleges: PropTypes.array.isRequired,
  setCollegeAppStatus: PropTypes.func.isRequired,
};

const ApplicationStatusCarousel = (props) => {
  const {colleges, setCollegeAppStatus} = props;

  const statusCards = map(colleges, (college) => (
    <ApplicationStatusCard
      key={college._id}
      id={college._id}
      name={college.name}
      logoImage={college.logo}
      setCollegeAppStatus={setCollegeAppStatus}
    />
  ));

  const showDoneCard = statusCards.length > 0 && statusCards.length < 4;
  const doneCard = showDoneCard ? <ApplicationStatusCard.Done key="done" /> : null;
  const cards = compact([...statusCards, doneCard]);

  return (
    <div className={styles.container} data-testid="application-status-carousel">
      <div className={styles.heading}>Where do you plan to apply?</div>
      <Carousel fade className={styles.sharedCarousel}>
        {cards}
      </Carousel>
    </div>
  );
};

ApplicationStatusCarousel.propTypes = propTypes;

export default ApplicationStatusCarousel;
